export const uploadAcceptedFileTypes = [
    ".pptx",
    ".pdf",
    ".docx",
    ".xlsx",
    ".png",
    ".jpg",
    ".mp4",
];

export const uploadlargeFileWarning =
    "For large files, it may take a few minutes for the preview to load in the side panel.";
